var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M104.78,28.21h-17.07l20.13-20.13c1.24-1.24,1.61-3.1.94-4.73-.67-1.62-2.24-2.67-4-2.67h-27.52c-2.39,0-4.33,1.94-4.33,4.33s1.94,4.33,4.33,4.33h17.07l-20.13,20.13c-1.24,1.24-1.61,3.1-.94,4.73.67,1.62,2.24,2.67,4,2.67h27.52c2.39,0,4.33-1.94,4.33-4.33s-1.94-4.33-4.33-4.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M91.02,76.37h-41.28c-2.39,0-4.33,1.94-4.33,4.33s1.94,4.33,4.33,4.33h30.83l-33.89,33.89c-1.25,1.24-1.62,3.09-.94,4.72.67,1.62,2.25,2.67,4,2.67h41.28c2.39,0,4.33-1.94,4.33-4.33s-1.94-4.33-4.33-4.33h-30.83l33.89-33.89c1.25-1.24,1.62-3.09.94-4.72-.67-1.62-2.25-2.67-4-2.67Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M54.07,60.06c0-2.39-1.94-4.33-4.33-4.33h-17.07l20.13-20.13c1.24-1.24,1.61-3.1.94-4.73-.67-1.62-2.24-2.67-4-2.67h-27.52c-2.39,0-4.33,1.94-4.33,4.33s1.94,4.33,4.33,4.33h17.07l-20.13,20.13c-1.24,1.24-1.61,3.1-.94,4.73.67,1.62,2.24,2.67,4,2.67h27.52c2.39,0,4.33-1.94,4.33-4.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.a3ccb49e324f49f6f49503d2044b33d0.svg";
export { ForwardRef as ReactComponent };